import { render, staticRenderFns } from "./AddServiceClientServiceDialog.vue?vue&type=template&id=573175f6&scoped=true&"
import script from "./AddServiceClientServiceDialog.vue?vue&type=script&lang=ts&"
export * from "./AddServiceClientServiceDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AddServiceClientServiceDialog.vue?vue&type=style&index=0&id=573175f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573175f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VIcon,VTextField})
